import React from 'react';
import { connect } from 'react-redux';
import Intro from './Intro';
import Background from './Background';
import Wall from './Wall';
import MobileView from './MobileView';

class Index extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    let currentStep = <Intro logo={this.props.logo} />
    if(this.props.settings.step == 1) {
      currentStep = <Intro
        logo={this.props.logo}
        introBackground={this.props.introBackground}
        step1={this.props.step1}
        step2={this.props.step2}
        step3={this.props.step3}
        step4={this.props.step4}
        cartIcon={this.props.cartIcon}
      />
    } else if(this.props.settings.step == 2) {
      currentStep = <Background
        logo={this.props.logo}
        introBackground={this.props.introBackground}
        cartIcon={this.props.cartIcon}
      />
    } else if(this.props.settings.step == 3) {
      currentStep = <Wall
        logo={this.props.logo}
        searchIcon={this.props.searchIcon}
        editIcon={this.props.editIcon}
        cartIcon={this.props.cartIcon}
        />
    }

    return(
      <React.Fragment>
        <MobileView introBackground={this.props.introBackground} />
        {currentStep}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  settings: state.settings
})

const mapDispatchToProps = {
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
